import type { ToasterProps } from 'sonner';
import { Toaster as ShadcnToaster } from '@shadcn/components/ui/sonner';
import { TITLE_BAR_HEIGHT_PX } from 'components/navbars/TitleBar.styles';

const GAP_BELOW_TITLE_BAR_PX = 16;

// Only the top is set: a plain number would move the side and bottom edges too.
const BELOW_TITLE_BAR = { top: TITLE_BAR_HEIGHT_PX + GAP_BELOW_TITLE_BAR_PX };

export function Toaster(props: ToasterProps) {
  return <ShadcnToaster offset={BELOW_TITLE_BAR} mobileOffset={BELOW_TITLE_BAR} {...props} />;
}
